import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: auto;
	min-height: 50vh;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 32px;
	margin-top: 32px;
	margin-bottom: 8px;
`;

const p = styled.p`
	font-weight: normal;
	font-size: 17px;
	margin: 0;
	margin-bottom: 32px;
`;

const ShopFrontSpraying = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Shop Front Spraying</Title>
			<p>
				If you are a proprietor or owner of a shop or retail outlet, you will
				know that presentation is everything and that the first impression talks
				for itself. <br />
				If your shop front or retail outlet is looking a little run down it
				could be time for some shop front spraying or shop front restoration.
				Advanced spray decorators can Carry out shop front spraying and
				restoration all across the UK and carry out the work out of Shopping and
				retail hours to ensure that work does not disrupt your business.
				<br />
				<ul>
					<li>Restore wooden frames to a ‘like a new’ state</li>
					<li>Strip and repair the timber framing</li>
					<li>Replace or fill in rotten timber</li>
					<li>
						Match the entire shop front colour to match existing colour or to
						give it a new colour for rebranding.{" "}
					</li>
				</ul>
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default ShopFrontSpraying;



// WEBPACK FOOTER //
// ./src/components/page/shop-front-spraying.js